import { h } from 'preact';
const CloseIcon = ({ className , width ='20' , height ='20' , stroke ='#13294b'  })=>h('svg', {
        'aria-hidden': 'true',
        xmlns: 'http://www.w3.org/2000/svg',
        width: String(width),
        height: String(height),
        viewBox: '0 0 20 20',
        fill: 'none',
        className
    }, h('path', {
        d: 'M3 3L16.9999 16.9999',
        stroke,
        'stroke-width': '1.25',
        'stroke-linecap': 'round'
    }), h('path', {
        d: 'M3 17L16.9999 3.00012',
        stroke,
        'stroke-width': '1.25',
        'stroke-linecap': 'round'
    }));
export default CloseIcon;
